export default __webpack_public_path__ + "static/media/2GalQuickFillKit_8_main.d85a4b69.png";